import script from "./HomeOptico.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeOptico.vue?vue&type=script&setup=true&lang=js"

import "./HomeOptico.vue?vue&type=style&index=0&id=6dafb451&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dafb451"]])

export default __exports__